






import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';
import Presentational from './presentational.vue';

@Component({
  components: { Presentational },
  computed: {
    ...mapGetters('Charactersheets', {
      gamesystem: 'getGameSystem',
      statuses: 'getStatus',
    }),
  },
  methods: {
    ...mapActions('Charactersheets', {
      updateStatus: 'updateStatus',
    }),
  },
})
export default class StatusContainer extends Vue {}
